import type { CharacterGearRow } from '@thottbot/shared';
import { ArtifactLink } from '../../components/ArtifactLink';
import { Badge } from '../../components/Badge';

/** One row per equipment slot: the item (linked when the database knows it), its enchant and the item's data status. */
export function GearTable({ gear }: { gear: CharacterGearRow[] }) {
  return (
    <div className="table-scroll">
      <table className="grid" data-testid="gear">
        <thead>
          <tr>
            <th>Slot</th>
            <th>Item</th>
            <th>Enchant</th>
          </tr>
        </thead>
        <tbody>
          {gear.map((row) => (
            <tr key={row.slot} data-testid="gear-row" data-slot={row.slot}>
              <th scope="row">{row.label}</th>
              <td>
                {row.item === null ? (
                  <span className="muted">empty</span>
                ) : row.item.slug ? (
                  <>
                    {row.item.iconUrl && <img className="icon" src={row.item.iconUrl} alt="" />}
                    <ArtifactLink
                      type="item"
                      slug={row.item.slug}
                      name={row.item.name}
                      className=""
                      quality={row.item.quality}
                      contextLines={row.enchant ? [`Enchant: ${row.enchant.text}`] : undefined}
                    />{' '}
                    {row.item.dataStatus && <Badge status={row.item.dataStatus} build={row.item.sourceBuild} />}
                  </>
                ) : (
                  <>
                    {row.item.name} <span className="muted">(not in database yet)</span>
                  </>
                )}
              </td>
              <td>
                {row.enchant &&
                  (row.enchant.recipeSlug ? (
                    <ArtifactLink type="recipe" slug={row.enchant.recipeSlug} name={row.enchant.text}>
                      {row.enchant.text}
                    </ArtifactLink>
                  ) : (
                    row.enchant.text
                  ))}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
